@if (stroke() !== undefined) {
  <hugeicons-icon
    class="fill-current stroke-current icon"
    [icon]="icon()"
    [strokeWidth]="stroke()!"
  />
} @else {
  <hugeicons-icon class="fill-current stroke-current icon" [icon]="icon()" />
}
